/* @flow */

import {
  sideBarLapWidth,
  sideBarTabletWidth,
  mainTabletWidth,
  mainLapWidth,
} from 'src/shared/app/base/component/template/style/template.style';
import { navDrawerElevation } from 'src/shared/app/base/style/token/elevation';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';

export default {
  root: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: navDrawerElevation,

    [tablet]: {
      left: sideBarTabletWidth,

      maxWidth: mainTabletWidth,
    },

    [lap]: {
      left: sideBarLapWidth,

      maxWidth: mainLapWidth,
    },
  },
};
